import { ReactElement } from 'react';

import { SkeletonFill } from '@/components';

import { SkeletonRecentActivityTableRow } from './SkeletonRecentActivityTableRow';

export const RecentActivityListLoading = (): ReactElement => {
  return (
    <SkeletonFill count={5}>
      <SkeletonRecentActivityTableRow />
    </SkeletonFill>
  );
};
